export {}

const printButtons = document.querySelectorAll<HTMLAnchorElement>(".js-print-button")

printButtons.forEach((button) => button.addEventListener("click", (e) => {
  e.preventDefault()
  const url = button.href
  const blank = button.classList.contains("--blank")
  if (url) window.open(url, blank ? "_blank" : "_self", "noopener")
}))